<template>
  <div class="h-full flex flex-col">
    <PreAnalysis v-if="view === 'pre-analysis'" @done="preAnalysisDone()"/>
    <PostAnalysis v-if="view === 'post-analysis'" @done="postAnalysisDone()"/>
    <Success v-if="view === 'success'"/>
  </div>
</template>

<script>
import PreAnalysis from "@/components/core/home/PreAnalysis.vue";
import view from '@/mixins/view.js';
import PostAnalysis from "@/components/core/home/PostAnalysis.vue";
import Success from "@/components/core/home/sections/Success.vue";

export default {
  name: "Analysis",
  components: { Success, PostAnalysis, PreAnalysis },
  mixins: [view],
  created() {
    const { stage, request_id } = this.$store.state.eligibility;
    if (request_id && stage && !stage.match(/^created|bank-statement$/gi)) return this.pushView('post-analysis');
    this.pushView('pre-analysis');
  },
  methods: {
    preAnalysisDone() {
      this.pushView('post-analysis');
    },
    postAnalysisDone() {
      this.pushView('success');
    },
  }
}
</script>
